// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pgjD","title":"styles_title__NX7Gj"};